/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CommonResponseDto,
  HTTPValidationError,
  UpdateUserDeviceRequestDto,
  UserResponseDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 토큰으로유저의정보를가져오는API
 * @summary UpdateUserDeviceInfo
 */
export const getUserInfo = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<UserResponseDto>(
      {url: `/user/`, method: 'GET', signal
    },
      options);
    }
  

export const getGetUserInfoQueryKey = () => {
    return [`/user/`] as const;
    }

    
export const getGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoQueryError = HTTPValidationError


export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary UpdateUserDeviceInfo
 */

export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserInfoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserInfoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoSuspenseQueryError = HTTPValidationError


export function useGetUserInfoSuspense<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserInfoSuspense<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetUserInfoSuspense<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary UpdateUserDeviceInfo
 */

export function useGetUserInfoSuspense<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserInfoSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 앱로그인시유저디바이스를등록하는API
 * @summary UpdateUserDeviceInfo
 */
export const updateUserDeviceInfo = (
    updateUserDeviceRequestDto: UpdateUserDeviceRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/user/device`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserDeviceRequestDto
    },
      options);
    }
  


export const getUpdateUserDeviceInfoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserDeviceInfo>>, TError,{data: UpdateUserDeviceRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserDeviceInfo>>, TError,{data: UpdateUserDeviceRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserDeviceInfo>>, {data: UpdateUserDeviceRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateUserDeviceInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserDeviceInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserDeviceInfo>>>
    export type UpdateUserDeviceInfoMutationBody = UpdateUserDeviceRequestDto
    export type UpdateUserDeviceInfoMutationError = HTTPValidationError

    /**
 * @summary UpdateUserDeviceInfo
 */
export const useUpdateUserDeviceInfo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserDeviceInfo>>, TError,{data: UpdateUserDeviceRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserDeviceInfo>>,
        TError,
        {data: UpdateUserDeviceRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserDeviceInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    